import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bf7c7422"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "x-data": "{ mobileNavOpen: false }" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("nav", { class: "lg:hidden py-6 px-6 border-b bg-white" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "text-2xl font-semibold",
      href: "#"
    }, " SCHOOLMEET.AI "),
    /*#__PURE__*/_createElementVNode("button", {
      "x-on:click": "mobileNavOpen = !mobileNavOpen",
      class: "flex items-center rounded focus:outline-none"
    }, [
      /*#__PURE__*/_createElementVNode("svg", {
        class: "text-white bg-indigo-500 hover:bg-indigo-600 block h-8 w-8 p-2 rounded",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor"
      }, [
        /*#__PURE__*/_createElementVNode("title", null, "Mobile menu"),
        /*#__PURE__*/_createElementVNode("path", { d: "M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" })
      ])
    ])
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "x-on:click": "mobileNavOpen = !mobileNavOpen",
  class: "fixed lg:hidden inset-0 bg-gray-800 opacity-10"
}, null, -1))
const _hoisted_4 = { class: "fixed top-0 left-0 bottom-0 flex flex-col w-3/4 lg:w-80 sm:max-w-xs pt-6 pb-8 bg-white border-r overflow-y-auto" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex w-full items-center px-6 pb-6 mb-6 lg:border-b border-blue-50" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-xl font-semibold",
    href: "#"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "h-8",
      src: "artemis-assets/logos/artemis-logo-light.svg",
      alt: "",
      width: "auto"
    })
  ])
], -1))
const _hoisted_6 = { class: "px-4 pb-6" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-2 text-xs uppercase text-gray-200 font-medium" }, "Main", -1))
const _hoisted_8 = { class: "mb-8 text-sm font-medium" }
const _hoisted_9 = { class: "hidden lg:block relative z-50" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed lg:hidden inset-0 bg-gray-800 opacity-10" }, null, -1))
const _hoisted_11 = { class: "fixed top-0 left-0 bottom-0 flex flex-col w-3/4 lg:w-80 sm:max-w-xs border-r overflow-y-auto bg-white" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex w-full items-center px-6 py-6 mb-6 lg:border-b border-blue-50 bg-gradient-to-r from-purple-200 via-pink-50 to-indigo-100" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-xl font-bold",
    href: "#"
  }, " SCHOOLMEET.AI ")
], -1))
const _hoisted_13 = { class: "px-4 pb-4" }
const _hoisted_14 = { class: "mb-8 text-sm font-medium" }
const _hoisted_15 = { class: "px-4 pb-4" }
const _hoisted_16 = { class: "mb-8 text-sm font-medium" }
const _hoisted_17 = { class: "px-4 pb-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-sm" }, "YÖNETİCİ İŞLEMLERİ", -1))
const _hoisted_19 = { class: "mb-8 text-sm font-medium" }
const _hoisted_20 = { class: "fixed bottom-0 lg:w-80 border-t border-r bg-slate-50 text-center py-2 pl-4 flex flex-row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-500" }, "Made with ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-4 w-4 text-red-500 fill-current mx-2",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z" })
], -1))
const _hoisted_23 = { class: "flex flex-row flex-1 justify-between" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-500" }, "in İstanbul", -1))
const _hoisted_25 = { class: "text-sm text-gray-500 pr-4" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-auto lg:ml-80" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass([{ 'block': _ctx.mobileNavOpen, 'hidden': !_ctx.mobileNavOpen }, "hidden relative z-50"])
    }, [
      _hoisted_3,
      _createElementVNode("nav", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.name
              }, [
                _createVNode(_component_router_link, {
                  to: item.path,
                  class: "flex items-center pl-3 py-3 pr-4 text-white bg-indigo-500 rounded",
                  "active-class": "flex items-center pl-3 py-3 pr-4 text-white bg-indigo-500 rounded"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("nav", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("ul", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teacherMenuItems, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.name
              }, [
                _createVNode(_component_router_link, {
                  to: item.path,
                  class: "flex items-center mt-1 pl-3 py-3 pr-2 text-gray-700 hover:bg-indigo-50 rounded",
                  "exact-active-class": " text-white bg-indigo-500 hover:text-black"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("ul", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parentMenuItems, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.name
              }, [
                _createVNode(_component_router_link, {
                  to: item.path,
                  class: "flex items-center mt-1 pl-3 py-3 pr-2 text-gray-700 hover:bg-indigo-50 rounded",
                  "exact-active-class": " text-white bg-indigo-500 hover:text-black"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("ul", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adminMenuItems, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.name
              }, [
                _createVNode(_component_router_link, {
                  to: item.path,
                  class: "flex items-center mt-1 pl-3 py-3 pr-2 text-gray-700 hover:bg-indigo-50 rounded",
                  "exact-active-class": " text-white bg-indigo-500 hover:text-black"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("footer", _hoisted_20, [
        _hoisted_21,
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("span", _hoisted_25, " v" + _toDisplayString(_ctx.VUE_APP_VERSION), 1)
        ])
      ])
    ]),
    _hoisted_26
  ]))
}